import React from 'react';

function ErrorContent({errorMessage}) {
    return (
        <div className="login-container d-flex align-items-center justify-content-center" style={{background: 'url(/waves-white.png)'}}>
            <div className="card shadow-lg p-4">
                <div className="card-body">
                    <img src="/logo.png" className="logo-login-top" alt="GeoTrace"/>
                    <div className="alert alert-dismissible alert-danger" style={{marginTop: '30px', marginBottom: '30px'}}>
                        <h4 className="alert-heading">Error</h4>
                        <p className="mb-0">{errorMessage}</p>
                    </div>
                    <div className="text-center">
                        <img src="/logo-footer.png" className="logo-login-bottom" alt="GeoTrace"/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErrorContent;